import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { connect, shallowEqual, useSelector } from 'react-redux'
import ToastrAction from 'toastr/actions/ToastrAction'
import Job from '../../../dto/DtoJob'
import SimpleFilterSelect from '../../../../components/forms/specific/SimpleFilterSelect'
import { IMPORT_TYPE } from 'traitements/constants/TraitementConstants'
import PurgeQuality from './PurgeQuality'
import RadioButtons from 'components/forms/RadioButtons'
import i18n from 'simple-react-i18n'
import { StyledFieldSet, StyledLegend } from 'components/StyledElements'
import { Grid } from '@mui/material'
import { omit } from 'lodash'
import Checkbox from '../../../../components/forms/Checkbox'

const PurgeOther = ({
    job,
    onChangeJob,
    isEditMode,
}) => {
    const {
        filterResults,
    } = useSelector(store => ({
        filterResults: store.StationReducer.filterResults,
    }), shallowEqual)


    const [filter, setFilter] = useState(job.parameters.filters.length ? JSON.parse(job.parameters.filters[0]) : { mode: 'station', types: '', deleteOnlyData: false })

    const onChangeCodesTypes = (changes) => {
        const filterTemp = { ...filter, ...changes }
        const resetFilter = ['filterId', 'stations', 'deleteOnlyData']
        setFilter(omit(filterTemp, resetFilter))
        const parameters = {
            ...job.parameters,
            filters: [JSON.stringify({
                ...omit(filterTemp, resetFilter),
                ...changes,
            })],
        }
        onChangeJob({ parameters })
    }

    const onChangeFilters = (changes) => {
        const parameters = {
            ...job.parameters,
            filters: [JSON.stringify({
                ...filter,
                ...changes,
            })],
        }
        setFilter({ ...filter, ...changes })
        onChangeJob({ parameters })
    }


    const codesTypes = [
        { code: IMPORT_TYPE.HYDRO_PORTAIL, name: i18n.hydroStation },
        { code: IMPORT_TYPE.PIEZO, name: i18n.piezometry },
        { code: IMPORT_TYPE.PLUVIO, name: i18n.pluviometry },
        { code: IMPORT_TYPE.QUALITO, name: i18n.quality },
    ]

    useEffect(() => {
        const resetFilter = {
            ...filter,
        }

        setFilter(resetFilter)
        const parameters = {
            ...job.parameters,
            filters: [JSON.stringify(resetFilter)],
        }

        onChangeJob({ parameters })
    }, [filter.types])

    return (
        <>
            <Grid mb={2}>
                <StyledFieldSet>
                    <StyledLegend>{i18n.options}</StyledLegend>
                    <RadioButtons
                        elements={codesTypes}
                        selected={filter.types}
                        onChange={ v => onChangeCodesTypes({ types: v }) }
                        disabled={!isEditMode}
                    />
                </StyledFieldSet>
            </Grid>
            {filter.types === IMPORT_TYPE.QUALITO && (
                <PurgeQuality
                    job={job}
                    onChangeJob={onChangeJob}
                    isEditMode={isEditMode}
                />
            )}
            {(filter.types === IMPORT_TYPE.HYDRO_PORTAIL || filter.types === IMPORT_TYPE.PIEZO || filter.types === IMPORT_TYPE.PLUVIO) && (
                <Grid container spacing={3}>
                    <Grid size={4} alignItems={'center'}>
                        <SimpleFilterSelect
                            key={filter.types}
                            onChange={(v, f) => onChangeFilters({
                                types: filter.types,
                                ...(f !== undefined ? { filterId: f } : {}),
                                ...(f && f !== -1 ? { stations: v.map(s => s.id) } : {}),
                            })}
                            stations={filterResults}
                            stationType={filter.types}
                            disabled={!isEditMode}
                            value={filter.filterId ?? -1}
                            ignoreCache
                        />
                    </Grid>
                    <Grid size={3} alignItems={'center'}>
                        <Checkbox
                            alignItems={'center'}
                            label={i18n.deleteOnlyData}
                            checked={!!filter.deleteOnlyData}
                            onChange={ v => onChangeFilters({ deleteOnlyData: v }) }
                            disabled={ !isEditMode }
                        />
                    </Grid>
                </Grid>
            )}
        </>
    )
}

PurgeOther.propTypes = {
    job: PropTypes.instanceOf(Job).isRequired,
    onChangeJob: PropTypes.func.isRequired,
    isEditMode: PropTypes.bool,
    type: PropTypes.string,

    toastrError: PropTypes.func,
}

const mapStateToProps = store => ({
    filterResults: store.StationReducer.filterResults,
})

const mapDispatchToProps = {
    toastrError: ToastrAction.error,
}

export default connect(mapStateToProps, mapDispatchToProps)(PurgeOther)
